import script from "./GameToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./GameToolbar.vue?vue&type=script&setup=true&lang=js"

import "./GameToolbar.vue?vue&type=style&index=0&id=e134bdee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e134bdee"]])

export default __exports__